import { Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import CardView from '../../../component/card/card-view';
import GlobalNotification from '../../../component/common/snackbar';
import DialogComponent from '../../../component/dialog/dialog.component';
import i18n from '../../../i18n';
import { Warrant } from '../../../models';
import apiManage from '../../../request';
import { AuthCard } from './auth-card';
import { AuthCardDialogSkeleton } from './auth-card-skeleton';
import { getAuthPointI18n } from '../../../constants/tool-auth-point';
import ButtonComponent from '../../../component/button/button.component';

// 添加授权方案
export function AuthPointDialog(
    props: {
        open: boolean;
        onCancel: () => void;
        /**
         * 区分操作的是集团还是餐厅
         * @param stringId 表示餐厅或集团的string_id字段
         * @param target 为 'GROUP' | 'RESTAURANT'
         */
        operations: { stringId: string, target: string };
        onClick: (selectAuth: Warrant) => void;
        // 选择授权点
        showSelectBox?: boolean;
        selectedWarrant?: Warrant[];
        onSave?: () => void;
        
    }
): JSX.Element {
    const { open, operations, onCancel, onClick, showSelectBox, selectedWarrant, onSave } = props
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [authPointList, setAuthPointList] = useState<Array<Warrant>>([]);
    const [collectList, setCollectList] = useState<Array<Warrant>>([]);

    useEffect(() => {
        if (open) {
            getStaticAuth();
        }
    }, [open]);

    // *********************
    // Service Function
    // *********************

    // 获取权限模板
    async function getStaticAuth() {
        setIsLoading(true);
        setAuthPointList([]);
        setCollectList([]);
        const language = i18n.language === 'CN' ? 'CN' : 'EN';
        const params = {
            key: language
        }
        // operationObject.target 根据父组s件给的值来判断是获取集团授权资源或是获取餐厅授权资源
        const result: any = operations.target === 'GROUP'
            ? await apiManage.get_group_static_warrant({ key: language, account_type: 'GROUP' })
            : await apiManage.get_static_warrant(params);

        if (!result?.error) {
            const { warrantCollection, warrantPoint } = result;
            setAuthPointList(warrantPoint);
            setCollectList(warrantCollection);
            setIsLoading(false);
        } else {
            GlobalNotification.error(i18n.t('warrant_page_msg_failed_obtain_authorization_data'));
        }
    }
    const cardViewArr: { type: 'ordinary' | 'collect' }[] = [
        { type: 'ordinary' },
        { type: 'collect' }
    ]
    // *********************
    // View
    // *********************

    return (
        <DialogComponent
            open={open}
            fullWidth={true}
            heightSize={'large'}
            onClose={() => { onCancel() }}
            defaultHeaderProps={{
                title: i18n.t('warrant_page_text_choose_authorization_scheme'),
                rightNode: onSave ? <ButtonComponent
                    variant='outlined'
                    color={'primary'}
                    handleClick={() => onSave?.()}
                    action={'SAVE'}
                    disabled={!authPointList.length}
                /> : undefined
            }}
        >
            <div className='addAuthPoint'>
                {isLoading
                    ? <AuthCardDialogSkeleton />
                    : cardViewArr.map((item) => {
                        const list = item.type === 'ordinary' ? authPointList : collectList;
                        return (
                            <CardView
                                key={item.type}
                                title={item.type === 'ordinary' ? i18n.t('warrant_page_text_authorization_scheme') : i18n.t('warrant_page_text_authorization_set')}
                                style={{ marginBottom: '1rem' }}
                                contentRender={<Box display={'flex'} flexWrap='wrap'>
                                    {list.length > 0 ?
                                        list?.map((wararntItem, wararntItemIndex) => {
                                            // 当前授权点是否选中
                                            const selected = showSelectBox ? selectedWarrant?.map(ele => ele.code).includes(wararntItem.code) : false;
                                            
                                            // 筛选出对应国际化授权名字
                                            const filterI18nName = getAuthPointI18n(wararntItem?.warranti18N?.name || []);
                                            return <AuthCard
                                                key={wararntItemIndex}
                                                name={filterI18nName}
                                                price={wararntItem.price}
                                                startDate={wararntItem?.start_date}
                                                endDate={wararntItem?.end_date}
                                                type={item.type === 'ordinary' ? 'chooser-single' : 'chooser-mltiple'}
                                                showSelectBox={!!showSelectBox}
                                                selected={!!selected}
                                                onClick={() => { onClick(wararntItem) }}
                                            />
                                        })
                                        : i18n.t('general_text_no_or_more_data')
                                    }
                                </Box>}
                            />
                        )
                    })}
            </div>
        </DialogComponent >
    )
}